
/**
 * converts hex color to rgb color
 * @param hex hex color string
 * @returns [r,g,b] values array
 */
export const hexToRGB = (hex: string) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return [r, g, b];
};
